import React, { useState } from 'react';
import './Home.css';
const Home = ({ addToHistory }) => {
  const [image, setImage] = useState(null);

  const fetchDogImage = async () => {
    const response = await fetch('https://dog.ceo/api/breeds/image/random');
    const data = await response.json();
    setImage(data.message);
    addToHistory(data.message);
  };
  

  return (
    <div className="row">
      <div className="col-12 text-center">
        <h1>Click To Fetch Image And Get Image ..</h1>
        {image && <img src={image} alt="dog" className="img-fluid img-set" />}
        <br />
        <button className="btn btn-primary mt-3" onClick={fetchDogImage}>
          Fetch New Image
        </button>
      </div>
    </div>
  );
};

export default Home;
